/**
 * Product Sticky Add to Cart
 * Shows the fixed purchase bar while the primary PDP CTA is outside the viewport.
 * Its price and item count always include the selected FBT accessories.
 * Main product sale price uses custom.final_price when present (product-level).
 */
(function () {
  "use strict";

  /**
   * 格式化价格
   * @param { number } cents
   * @returns { string }
   */
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.strings && window.theme.strings.moneyFormat);
    }
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  /**
   * 获取 FBT 商品项的集合
   * @returns { Object }
   */

  /**
   * Normalizes Liquid cent values and formatted storefront prices to cents.
   * VariantPicker emits prices such as "$99.99", while Liquid data attributes
   * already contain integer cents such as "9999".
   *
   * @param {number|string} value
   * @returns {number}
   */
  function toCents(value) {
    if (typeof value === "number") return Number.isFinite(value) ? Math.round(value) : 0;

    var raw = String(value == null ? "" : value).trim();
    if (!raw) return 0;

    var normalized = raw.replace(/[^0-9.,-]/g, "").replace(/,/g, "");
    var amount = Number(normalized);
    if (!Number.isFinite(amount)) return 0;

    return normalized.indexOf(".") !== -1 ? Math.round(amount * 100) : Math.round(amount);
  }
  function getFbtState() {
    if (window.ProductBlockFbt && typeof window.ProductBlockFbt.getBundleState === "function") {
      return window.ProductBlockFbt.getBundleState();
    }
    return { quantity: 0, saleTotal: 0, compareTotal: 0 };
  }

  /**
   * 更新添加到购物车按钮的变体 ID
   * @param { HTMLElement } root
   * @param { Object } variant
   */
  function updateActions(root, variant) {
    root.querySelectorAll("open-cart-drawer, add-to-cart").forEach(function (button) {
      button.setAttribute("variant-id", variant.id);
    });
  }

  /**
   * 解析主商品售价与划线价
   * @param { HTMLElement } root
   * @param { Object } variant
   * @returns {{ mainPrice: number, mainCompare: number }}
   */
  function resolveMainPrices(root, variant) {
    var hasFinalPrice = root.dataset.hasFinalPrice === "true";
    var mainPrice = hasFinalPrice
      ? toCents(root.dataset.mainPrice)
      : toCents(variant.price);
    var mainCompare = toCents(variant.compare_at_price || variant.price || mainPrice);

    if (mainCompare < mainPrice) {
      mainCompare = toCents(variant.price || mainPrice);
    }

    if (mainCompare < mainPrice) {
      mainCompare = mainPrice;
    }

    return { mainPrice: mainPrice, mainCompare: mainCompare };
  }

  /**
   * 渲染添加到购物车按钮
   * @param { HTMLElement } root
   * @param { Object } state
   */
  function render(root, state) {
    var fbt = state.fbt || getFbtState();
    var prices = resolveMainPrices(root, state.variant);
    var mainPrice = prices.mainPrice;
    var mainCompare = prices.mainCompare;

    var price = mainPrice + Number(fbt.saleTotal || 0);
    var compare = mainCompare + Number(fbt.compareTotal || 0);
    var hasDiscount = compare > price;
    var discount = hasDiscount ? Math.round((compare - price) * 100 / compare) : 0;
    var quantity = 1 + Number(fbt.quantity || 0);

    root.querySelectorAll("[data-sticky-atc-price]").forEach(function (element) {
      element.textContent = formatMoney(price);
    });
    root.querySelectorAll("[data-sticky-atc-compare]").forEach(function (element) {
      element.hidden = !hasDiscount;
      if (hasDiscount) element.textContent = formatMoney(compare);
    });
    root.querySelectorAll("[data-sticky-atc-discount]").forEach(function (element) {
      element.hidden = discount <= 0;
      if (discount > 0) element.textContent = discount + "% OFF";
    });
    root.querySelectorAll("[data-sticky-atc-count]").forEach(function (element) {
      element.textContent = quantity + (quantity === 1 ? " item" : " items") + " in total";
    });
  }

  /**
   * 初始化 sticky-add-to-cart
   * @param { HTMLElement } root
   */
  function init(root) {
    if (!root || root.dataset.stickyAtcInit === "1") return;
    var target = document.querySelector(root.dataset.targetSelector);
    if (!target || !window.IntersectionObserver) return;

    root.dataset.stickyAtcInit = "1";
    var actions = root.querySelector("[data-sticky-atc-actions]");
    var initialVariant = {
      id: 0,
      price: Number(root.dataset.mainPrice || 0),
      compare_at_price: Number(root.dataset.mainCompareAtPrice || root.dataset.mainPrice || 0),
      available: !actions.hidden,
    };
    var state = {
      variant: initialVariant,
      fbt: getFbtState(),
    };

    var observer = new IntersectionObserver(function (entries) {
      root.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { threshold: 0.01 });
    observer.observe(target);

    document.addEventListener("product:variant:change", function (event) {
      var variant = (event.detail || {}).variant;
      if (!variant) return;

      state.variant = variant;
      var soldOut = root.querySelector("[data-sticky-atc-sold-out]");
      if (actions) actions.hidden = !variant.available;
      if (soldOut) soldOut.hidden = !!variant.available;
      updateActions(root, variant);
      render(root, state);
    });

    document.addEventListener("product:fbt:change", function (event) {
      state.fbt = event.detail || getFbtState();
      render(root, state);
    });

    render(root, state);
  }

  /**
   * 初始化所有 sticky-add-to-cart
   * @param { HTMLElement } scope
   */
  function initAll(scope) {
    (scope || document).querySelectorAll("[data-sticky-add-to-cart]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
